import { useWSModal, WSForm } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import * as Yup from "yup";
import { useWSMutation } from "../../../../../query/helpers";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../../../query/users/queries";
import { selectorMemberCountry } from "../../../../../shared/selectors/selectorMemberCountry";
import { entityDataService } from "../../../../../shared/services/entityData";
import { WSServiceError } from "../../../../../utils/serviceHelper";
import {
  FormDataAddress,
  FormPartialAddress,
  getProfileDataAddress
} from "../../../../Onboarding/components/FormPartialAddress";
import { getValidationSchemaAddress } from "../../../../../shared/validators/address/validationSchemaAddress";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: FormDataAddress };

type Props = {
  onClose: () => void;
};

export const FormEditAddress: React.FC<Props> = props => {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);

  const country = useMemo(
    () => (queryMember.data ? selectorMemberCountry(queryMember.data) : "US"),
    [queryMember.data]
  );

  const [mutate, meta] = useWSMutation<void, WSServiceError, FormData>(
    async data => {
      await entityDataService.updateEntity(
        {
          address: data.newValue
        },
        {
          userId
        }
      );
    },
    {
      onSuccess: props.onClose
    }
  );

  return (
    <WSForm<FormData>
      onSubmit={mutate}
      defaultValues={{ newValue: getProfileDataAddress(queryMember.data) }}
      validationSchema={Yup.object({
        newValue: getValidationSchemaAddress(country)
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <FormPartialAddress country={country} name="newValue" />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditAddress = () =>
  useWSModal(FormEditAddress, {
    title: "Address",
    size: "S"
  });
